import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import HamburgerMenu from '../ui/HamburgerMenu';

function currentUserRole(): string | null {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw).role : null;
  } catch {
    return null;
  }
}

export default function MainLayout() {
  const [theme, setTheme] = React.useState<'dark' | 'light'>('dark');
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  React.useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const isLight = theme === 'light';
  const isAdmin = currentUserRole() === 'admin';

  return (
    <div className="appRoot">
      <header className="siteHeader">
        <div className="container headerInner">
          <Link to="/" className="brand" aria-label="SafariCo Hub Home">
            <img className="brandLogo" src="/images/brand/safarico-hub-logo.png" alt="" />
            <div>
              <div className="brandName">SafariCo Hub</div>
              <div className="brandTag">Ethical Journeys. Real Impact.</div>
            </div>
          </Link>

          <div className="headerActions">
            <HamburgerMenu
              isOpen={mobileMenuOpen}
              onToggle={() => setMobileMenuOpen((v) => !v)}
              onClose={() => setMobileMenuOpen(false)}
              links={[
                { label: 'About SafariCo Hub', to: '/about' },
                { label: 'Impact Review', to: '/impact' },
                { label: 'Our Expertise', to: '/expertise' },
                { label: 'Partner With Us', to: '/partner' },
                ...(isAdmin ? [{ label: 'Review Applications', to: '/admin/verifications' }] : []),
              ]}
            />

            <button
              className="themeToggle"
              type="button"
              aria-label={`Switch to ${isLight ? 'dark' : 'light'} theme`}
              title={`Switch to ${isLight ? 'dark' : 'light'} theme`}
              onClick={() => setTheme(isLight ? 'dark' : 'light')}
            >
              {isLight ? 'Dark' : 'Light'}
            </button>
          </div>

          <nav className="nav">
            <NavLink to="/about" className={({ isActive }) => (isActive ? 'navLink active' : 'navLink')}>
              About SafariCo Hub
            </NavLink>
            <NavLink
              to="/impact"
              className={({ isActive }) => (isActive ? 'navLink active' : 'navLink')}
            >
              Impact Review
            </NavLink>
            <NavLink
              to="/expertise"
              className={({ isActive }) => (isActive ? 'navLink active' : 'navLink')}
            >
              Our Expertise
            </NavLink>
            <NavLink
              to="/partner"
              className={({ isActive }) => (isActive ? 'navLink active' : 'navLink')}
            >
              Partner With Us
            </NavLink>
            {isAdmin && (
              <NavLink
                to="/admin/verifications"
                className={({ isActive }) => (isActive ? 'navLink active' : 'navLink')}
              >
                Review Applications
              </NavLink>
            )}
          </nav>


        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="siteFooter">
        <div className="container footerInner">
          <div className="footerCol">
            <div className="footerTitle">Mission</div>
            <div className="footerText">
              SafariCo Hub is a non-profit association connecting travelers, agents, and East
              African communities. Every booking and every donation funds conservation, education,
              and community-led development — because the people protecting these lands deserve
              to share in what they generate.
            </div>
            <div className="footerBottom">Copyright {new Date().getFullYear()} SafariCo Hub</div>
          </div>

          <div className="footerCol">
            <div className="footerTitle">Learn more</div>
            <div className="footerLinks">
              <a className="footerLink" href="#">
                Impact Reports
              </a>
              <a className="footerLink" href="#">
                Community Partners
              </a>
              <a className="footerLink" href="#">
                Contact
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

